import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

export function FloatingButton() {
    const { header } = useStaticQuery(graphql`
        query FloatingButtonQuery {
            header: datoCmsHeader {
                button {
                    title
                    link
                }
            }
        }
    `)

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const isMobile = () => window.matchMedia("(max-width: 768px)").matches

        const checkVisibility = () => {
            if (isMobile()) {
                setVisible(document.body.classList.contains("menu-open"))
                return
            }

            const scrollVisible = window.scrollY > 35
            const footer = document.querySelector("footer")

            if (!footer) {
                setVisible(scrollVisible)
                return
            }

            const footerTop = footer.getBoundingClientRect().top
            const windowHeight = window.innerHeight
            const isFooterVisible = footerTop < windowHeight - 100

            setVisible(scrollVisible && !isFooterVisible)
        }

        const observer = new MutationObserver(checkVisibility)

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"],
        })

        window.addEventListener("scroll", checkVisibility)
        window.addEventListener("resize", checkVisibility)

        checkVisibility()

        return () => {
            observer.disconnect()
            window.removeEventListener("scroll", checkVisibility)
            window.removeEventListener("resize", checkVisibility)
        }
    }, [])

    const button = header.button

    if (!button) return null

    return (
        <a href={button.link} rel='noopener noreferrer' className={`floating-button form-submit p-sans${visible ? " visible" : ""}`}>
            {button.title} &rarr;
        </a>
    )
}